export const CAST_CATEGORIES = ["TBP", "Gen", "OBC", "SC","ST"];

export const RELIGIONS = [
  "Hindu",
  "Muslim",
  "Christian",
  "Sikh",
  "Jew",
  "Buddhist",
  "Jain",
];

export const EDUCATION_LEVELS = [
  "5th to 8th",
  "9th to 10th",
  "11th to 12th",
  "Under Graduate",
  "Graduate",
  "Post Graduate",
  "Un Educated",
];

export const GENDERS = ["Male", "Female", "Transgender"];

export const MARITAL_STATUSES = ["Unmarried", "Married", "Divorcee", "Widower"];

export const PRETRAINING_STATUS = [
  "Fresher",
  "Experienced",
  "Student",
  "Self-employed",
];

export const DISABILITY_STATUS = ["Yes", "No"];

export const STATE = ["Andhra Pradesh", "Arunachal Pradesh", "Assam",
            "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
            "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
            "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
            "Uttar Pradesh", "Uttarakhand", "West Bengal"];